export interface Game {
    id: string
    title: string
    description: string
    image: string
    link: string
    tags: string[]
    developer?: string
  }
  
  export const games: Game[] = [
    {
      id: "1",
      title: "Lights Out",
      description: "Game logika mematikan semua lampu di grid. Setiap klik mengubah keadaan lampu yang dipilih dan sekitarnya.",
      image: "https://i.imgur.com/BRhSh0r.png",
      link: "https://lights-out-2b5.pages.dev/",
      tags: [],
      developer: "",
    },
    {
      id: "2",
      title: "Mix or Match",
      description: "Pilih 2 kartu yang sama untuk memenangkan permainan!",
      image: "https://i.imgur.com/ZEQcJSA.png",
      link: "https://mix-or-match-8id.pages.dev/",
      tags: [],
      developer: "",
    },
    {
      id: "3",
      title: "Claw Machine",
      description: "Game mesin capit klasik, gunakan kontrol untuk menggerakkan capit dan ambil hadiahnya!",
      image: "https://i.imgur.com/bhAfJKc.png   ",
      link: "https://claw-machine-rpl.pages.dev/",
        tags:[],
      developer: "",
    },
    {
      id: "4",
      title: "House Building Game",
      description: "Game sederhana untuk membangun rumah yang unik.",
      image: "https://i.imgur.com/39lgbj4.png",
      link: "https://house-build-game.pages.dev/",
        tags:[],
      developer: "",
    },
    {
      id: "5",
      title: "Lava Game",
      description: "Game platformer di mana kamu harus menyelesaikan level dan mengumpulkan semua koin sambil menghindari lava.",
      image: "https://i.imgur.com/CyD8nob.png",
      link: "https://lava-game.pages.dev/",
        tags:[],
      developer: "",
    },
    {
      id: "6",
      title: "Snake",
      description: "Evolusi dari game Snake klasik! Kendalikan ular untuk memakan makanan dan tumbuh lebih panjang.",
      image: "https://i.imgur.com/gQbJEfe.png",
      link: "https://snake-game-rpl.pages.dev/",
      tags: [],
      developer: "",
    },
  ]
  